import { PickupParticipantListPage } from "components/shared/pickupParticipants";

export const PAGE_SIZE = 10;

const WPSCheckinSportParticipantsListPage = () => (
  <PickupParticipantListPage kind="sport" variant="wps" />
);

export default WPSCheckinSportParticipantsListPage;
